import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {MenuItem} from '../Models/menuItem';
import {AuthorizationCheck} from '../auth/authorizationCheck';
import {menuComponentFromTo} from '../Models/menuComponentFromTo';

@Component({
  selector: 'app-masterpage',
  templateUrl: './masterpage.component.html',
  styleUrls: ['./masterpage.component.css']
})
export class MasterPageComponent implements OnInit {

  constructor(private route: Router) { }

  rota = this.route.url;
  pageTitle: string;
  pageTitleId: string;

  setPageTitle(menuItems: MenuItem[]) {

    // Encontra em 'menuComponentFromTo' o objeto que combina com a rota atual
    const currentPage = menuComponentFromTo.find(
      i => i.routeMenu
        === this.rota.match(/[a-zA-z]+/)[0]);

    // Se este objeto já possui a propriedade de título, posso pegar o título diretamente do objeto
    if (currentPage && currentPage.title) {
      this.pageTitle = document.title = currentPage.title;
      this.pageTitleId = currentPage.title.normalize('NFD').replace(/[\u0300-\u036f( )+]/g, '');

    // Senão (se este objeto não possui a propriedade de título), preciso identificar seu nome para usá-lo como título
    } else {

      menuItems.forEach((item) => {
        if (item.url && item.url.indexOf('.aspx') > -1) {
          const menuRoute = menuComponentFromTo.find(e => e.urlMenu === item.url);

          if (menuRoute !== undefined) {
            if (menuRoute.routeMenu === this.rota.replace('/', '')) {
              // definindo o título dentro da página (card) e o título no navegador
              this.pageTitle = document.title = item.name;
              this.pageTitleId = item.name.normalize('NFD').replace(/[\u0300-\u036f( )+]/g, '');
              return;
            }
          }
        }
        if (item.children && item.children.length > 0) {
          this.setPageTitle(item.children);
        }
      });
    }
  }

  closeSideBarDropDown() {
    // fechar os dropdown quando o menu estiver collapsado
    const li = document.getElementsByClassName('liParent');
    for (let i = 0; i < li.length; i++) {
      const el = document.getElementById(li[i].id);
      el.classList.remove('menu-is-opening', 'menu-open');
    }
  }

  ngOnInit() {
    if (localStorage.getItem('navMenu')) {
      this.setPageTitle(JSON.parse(localStorage.getItem('navMenu')));
    }
  }

  getPageTitleId(name: string) {
    return `id_tit_${name.normalize('NFD').replace(/[\u0300-\u036f( )+]/g, '')}`;
  }

}
